import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { MediaModule } from 'src/layout/media/media.module';
import { ButtonElementComponent } from './button.component';
import { IsExternalPipe } from './is-external.pipe';
import { IsInternalPipe } from './is-internal.pipe';
import { IsScriptPipe } from './is-script.pipe';
import { SettingsDirective } from './settings.directive';


@NgModule({
    declarations: [
        ButtonElementComponent,
        IsExternalPipe,
        IsInternalPipe,
        IsScriptPipe,
        SettingsDirective,
    ],

    imports: [
        CommonModule,
        NavigationModule,
        MediaModule,
        TagManagerModule,
    ],
})
export class ButtonElementModule {
    static components = {
        'buttonElement': ButtonElementComponent,
        'anchorButtonElement': ButtonElementComponent
    };
}
